// extracted by mini-css-extract-plugin
export default {"iconButton":"icon-button__iconButton"};